<template>
    <div class="TrainingServicesWarp">
        <NavMenu/>
        <!-- <img :src="img1" alt="" class="topimgbox" @click="golearPageFn"> -->
        <div class="imgwarp">
            <el-carousel :interval="10000" arrow="never" ref="carouselRef" :height="bannerHeight+'px'">
                <el-carousel-item v-for="(item,i) in carouselData" :key="i">
                    <el-row :gutter="12">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="height:340px;margin-bottom: 20px;">
                            <img ref="bannerHeight" :src="item.img" style="width: 100%;cursor: pointer" @load="imgLoad" @click="golearPageFn(item)">
                        </el-col>
                    </el-row>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="centerwarp">
            <div class="trainBox">
                <div class="leftbox">
                    <!-- <div v-for="(item,i) in MbaData" :key="i" class="itemMbaBox"> -->
                    <!-- {{item}} -->
                    <!-- <div class="itemMbaBox"> -->
                    <!-- <img :src="srcUrl+item.trainPhoto" class='mbaImg' @click="goDetailMba(item)"> -->
                    <!-- <div v-if="item.status==2" class="title">敬请期待</div> -->
                    <!-- </div> -->
                    <!-- </div> -->
                    <div class="informBox">
                        <!-- <div class="commonTabTitleBox">
                            <span class="title">
                                <span></span>
                                </span>
                            <span class="morebox" @click="gonewsecond1">
                                更多
                                <i class="el-icon-caret-right"></i>
                            </span>
                            
                        </div> -->
                        <div class="rightMore" @click="gonewsecond">
                            <span class="morebox">
                                更多
                                <i class="el-icon-caret-right"></i>
                            </span>
                        </div>
                        <div class="inforDataBox">
                            <div class="inforItemBox" v-for="(item,index) in MbaData" :key="index" @click="goNewsDetailFn(item)">
                                <img class="mbaImg" :src="srcUrl+item.titleImgUrl" />
                                <!-- <div class="msgbox">
                                    <div class="headlineBox overflowtwo">{{item.pressTopic}}</div>
                                    <div class="time">{{item.pressTime | timer}}</div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rightbox">
                    <div class="trainBox1">
                        <div class="infoSearchBox">
                            <div class="commonTabTitleBox">
                                <span class="title">
                                    <span class="line"></span>信息查询</span>
                            </div>
                            <div>
                                <div class="searchTextBox">
                                    <div v-for="(item,index) in searchList" :key="index" :class="currentSearch==item.name?'activesearchItem':'searchItem'" @click="changeSearchFn(item)">
                                        {{item.name}}
                                    </div>
                                </div>
                                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="formwarp">
                                    <el-form-item label="姓名" prop="names">
                                        <el-input v-model="ruleForm.names"></el-input>
                                    </el-form-item>
                                    <el-form-item label="身份证号码" prop="cardCode">
                                        <el-input v-model="ruleForm.cardCode"></el-input>
                                    </el-form-item>
                                    <el-button class="submintBtn" type="primary" @click="submitForm('ruleForm')">立即查询</el-button>
                                </el-form>
                            </div>
                        </div>
                    </div>
                    <div class="informBox">
                        <div class="commonTabTitleBox">
                            <span class="title">
                                <span class="line"></span>培训通知</span>
                            <span class="morebox" @click="gonewsecond1">
                                更多
                                <i class="el-icon-caret-right"></i>
                            </span>
                        </div>
                        <div class="inforDataBox">
                            <div class="inforItemBox" v-for="(item,index) in DataList" :key="index" @click="goNewsDetailFn(item)">
                                <el-image class="imgbox" :src="srcUrl+item.titleImgUrl"></el-image>
                                <div class="msgbox">
                                    <div class="headlineBox">{{item.pressTopic}}</div>
                                    <div class="time">{{item.pressTime | timer}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 课程列表 -->
                    <div v-if="CourseData.length!=0">
                        <!-- <div class="titleWarp" @click="gonewsecond2">
                            <div class="title">培训报名</div>
                            <div class="morebox">
                                更多
                                <i class="el-icon-caret-right"></i>
                            </div>
                        </div> -->
                        <div class="commonTabTitleBox rightsecondbox">
                            <span class="title">
                                <span class="line"></span>培训报名</span>
                            <span class="morebox" @click="gonewsecond2">
                                更多
                                <i class="el-icon-caret-right"></i>
                            </span>
                        </div>
                        <div class="trainListBox">
                            <div class="trainItem" v-for="(item,index) in CourseData" :key="index">
                                <div @click="gocourseDetailFn(item)" style="cursor: pointer">
                                    <div class="name overflowtwo">{{item.trainCourse}}</div>
                                    <div class="courseinfobox">
                                        <!-- <div>课程编码：
                                            <span>{{item.trainCode}}</span>
                                        </div> -->
                                        <div>课程起止时间：
                                            <span>{{item.startTime}}至{{item.endTime}}</span>
                                        </div>
                                        <div class="overflowone">课程地点：
                                            <span>{{item.trainSite}}</span>
                                        </div>
                                        <div class="overflowone">培训费用：
                                            <span>{{item.pay}}</span>
                                        </div>
                                        <!-- <div>招报人数：
                                            <span>{{item.playNumber}}</span>
                                        </div>
                                        <div>报名截止：
                                            <span class="deadlinebox">{{item.deadline}}</span>
                                        </div> -->
                                    </div>
                                </div>
                                <!-- <div class="coursdeadline" v-if="!token" @click="showlogindialog">
                            报名请先登录
                        </div> -->
                                <div v-if="!item.isApply">
                                    <div v-if="item.joinNumber==item.playNumber" class="registeredbox">
                                        已满员
                                    </div>
                                    <div v-else class="immediatelyBtn" @click="singUpFn(item)">
                                        立即报名
                                    </div>
                                </div>
                                <div v-else>
                                    <!-- <div class="registeredbox" v-if="item.isApply!='报名截止'&&item.isApply!='已结束'">
                                        {{item.isApply}}
                                    </div> -->
                                    <div class="registeredbox" style="cursor: pointer;" v-if="item.isApply!='报名截止'&&item.isApply!='已结束'" @click="singUpFn(item)">
                                        {{item.isApply}}
                                    </div>
                                    <div class="coursdeadline" v-if="item.isApply=='报名截止'">
                                        {{item.isApply}}
                                    </div>
                                    <div class="coursdeadline" v-if="item.isApply=='已结束'">
                                        {{item.isApply}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="emptyBox" v-else>
                        <img src="@/assets/imgs/home/emptyimg.png" />
                    </div>
                </div>
            </div>
            <!-- <div class="primaryTitle">
                <span class="left-line"></span>
                <span class="title">精选课程</span>
                <span class="right-line"></span>
            </div>
            <div>
                <div class="rightMore" @click="gonewsecond3">
                    <span class="morebox">
                        更多
                        <i class="el-icon-caret-right"></i>
                    </span>
                </div>
                <div class="selectedCourseBox">
                    <div class="centerMenubox">
                        <div class="Courseimg" @click="goleadFn">
                            <img src="@/assets/imgs/train/courseimg1.png" />
                        </div>
                        <div class="Courseimg">
                            <img src="@/assets/imgs/train/courseimg2.png" />
                            <div class="textbox">暂未开课</div>
                        </div>
                        <div class="Courseimg">
                            <img src="@/assets/imgs/train/courseimg3.png" />
                            <div class="textbox">暂未开课</div>
                        </div>
                        <div class="Courseimg">
                            <img src="@/assets/imgs/train/courseimg4.png" />
                            <div class="textbox">暂未开课</div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div style="marginTop:20px">
            <Footer/>
        </div>
        <!-- 提示登录 -->
        <el-dialog title="" :visible.sync="loginVisible" width="805px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'>
            <div class="dialogcenter">
                <h3>报名请先登录</h3>
                <span class="text">
                    此功能为网站用户开放，如需报名请先登录
                </span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="gologin">登录</el-button>
                <el-button @click="offloginVisible">不用了,谢谢</el-button>
            </span>
        </el-dialog>
        <!-- 课程报名 -->
        <CourseSingupModal :isShow.sync="singupVisible" v-if="singupVisible" :currentCourse='currentCourse' @successApplyFn='successApplyFn'
        />
        <!-- 課程报名信息查询 -->
        <el-dialog :title="currentSearch" :visible.sync="infoVisible" width="1200px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
            :close-on-click-modal='false' :append-to-body="true">
            <div class="singupdialogcenter">
                <div class="text">信息查询</div>
                <el-form :model="ruleForm" ref="ruleForm" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="姓名:" prop="names" label-width="60px">
                                <el-input v-model="ruleForm.names"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="身份证号码:" prop="cardCode" label-width="120px">
                                <el-input v-model="ruleForm.cardCode"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <div class="submintBtn" @click="submitForm('ruleForm')">立即查询</div>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="datawarp">
                    <div class="searchbox">
                        <div v-for="(item,index) in dialogList" :key="index" :class="dialogcurrentSearch==item.name?'activesearchItem':'searchItem'"
                            @click="dialogSearchFn(item)">
                            {{item.name}}
                        </div>
                    </div>
                    <div v-if="dialogcurrentSearch=='报名信息'">
                        <div v-if="infoDataList.length!=0">
                            <div class="datalistBox">
                                <div class="trainItem" v-for="(item,index) in infoDataList" :key="index">
                                    <div class="name overflowone">{{item.trainCourse}}</div>
                                    <div class="courseinfobox">
                                        <div>课程编码：
                                            <span>{{item.trainCode}}</span>
                                        </div>
                                        <div class="overflowone">培训费用：
                                            <span>{{item.pay}}</span>
                                        </div>
                                        <div>招报人数：
                                            <span>{{item.playNumber?item.playNumber:'-'}}</span>
                                        </div>
                                        <div>报名截止：
                                            <span class="deadlinebox">{{item.deadline}}</span>
                                        </div>
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==98">
                                        预审通过
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==1">
                                        预审审核中
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==198">
                                        预审审核失败
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==99">
                                        信息审核中
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==100">
                                        信息审核通过
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==199">
                                        信息审核失败
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==101">
                                        文件审核中
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==3">
                                        文件审核失败
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==2">
                                        待缴费
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==4">
                                        报名完成
                                    </div>
                                    <div class="registeredbox" v-if="item.audit==6">
                                        培训完成
                                    </div>
                                </div>
                            </div>
                            <div style="textAlign:center">
                                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                                    :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                                    :total="total">
                                </el-pagination>
                            </div>
                        </div>
                        <div v-else class="searchempty">
                            <img src="@/assets/imgs/train/img1.png" />
                        </div>
                    </div>
                    <div v-if="dialogcurrentSearch=='成绩证书'">
                        <div v-if="certificateList.length!=0">
                            <div class="pdfdatabox">
                                <div class="pdfItem" v-for="(item,index) in certificateList" :key="index">
                                    <div class="pdftop">
                                        <div class="certificateName" v-if="item.certificateName">证书名称：{{item.certificateName}}</div>
                                        <div v-if="item.certificateCode">证书编号：{{item.certificateCode}}</div>
                                    </div>
                                    <div class="pdfbotbox">
                                        <div class="downbox" v-if="item.certificateUrl" @click="downloadFn(item.certificateUrl)">
                                            <img src="@/assets/imgs/train/bgimg2.png" />
                                            <span class="downicon">
                                                <i class="el-icon-download icon" />
                                            </span>
                                        </div>
                                        <div class="courseinfobox">
                                            <div class="name overflowone">{{item.trainCourse}}</div>
                                            <div class="infotext">姓名：
                                                <span>{{ruleForm.names}}</span>
                                            </div>
                                            <div class="infotext">身份证号码：
                                                <span>{{ruleForm.cardCode}}</span>
                                            </div>
                                            <div class="infotext ">成绩：
                                                <span class="score">{{item.score}}</span>
                                            </div>
                                            <div class="infotext" v-if="item.certificateUrl">发证时间：
                                                <span class="deadlinebox">{{item.creationTime | timer}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="textAlign:center">
                                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                                    :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                                    :total="certificatetotal">
                                </el-pagination>
                            </div>
                        </div>
                        <div v-else class="searchempty">
                            <img src="@/assets/imgs/train/img1.png" />
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="primary" @click="gologin">好的</el-button> -->
                <el-button @click="offmodalFn">关闭</el-button>
            </span>
        </el-dialog>
        <!--  领军人才报名-->
        <!-- <LeadSingupModal :isShow.sync="leadsingupVisible" v-if="leadsingupVisible" @offseconfModal='offseconfModal' :leartrainData='leartrainData'
        /> -->
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import CourseSingupModal from './CourseSingupModal.vue'
import { httpService, headerSrcUrl } from "@/service/httpService";
// import LeadSingupModal from './LeadSingupModal'
export default {
    components: {
        NavMenu,
        Footer,
        CourseSingupModal,
        // LeadSingupModal
    },
    data() {
        return {

            srcUrl: headerSrcUrl,
            DataList: [],
            searchList: [
                { name: '报名信息查询' },
                { name: '成绩证书查询' },
            ],
            currentSearch: '报名信息查询',
            currentPage: 1,
            pageSize: 10,
            total: null,
            ruleForm: {
                names: '',
                cardCode: '',
            },
            rules: {
                names: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                // pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                cardCode: [
                    { required: true, message: '请输入正确的身份证号码',   trigger: 'blur' }
                ],
            },
            infoDataList: [],
            certificateList: [],
            certificatetotal: null,
            infoVisible: false,
            // dialogForm: {
            //     userName: '',
            //     cardCode: '',
            // },
            dialogList: [
                { name: '报名信息' },
                { name: '成绩证书' },
            ],
            dialogcurrentSearch: '报名信息',
            lefticon: require("@/assets/imgs/branch/lefticon.png"),
            righticon: require("@/assets/imgs/branch/activaterighticon.png"),
            // 判断是否登录
            token: sessionStorage.getItem('token'),
            loginVisible: false,
            singupVisible: false,
            CourseData: [],
            currentCourse: null,//当前报名的课程
            // islogin: sessionStorage.getItem('token'),
            // leartrainData: null,
            // leadsingupVisible:false,
            MbaData: [],
            img1: require("@/assets/imgs/lead/img4.jpg"),
            carouselData: [
                { img: require("@/assets/imgs/lead/img4.jpg"), url: '/leade-talent' },
                { img: require("@/assets/imgs/lead/img5.png"), url: '/joint-activity' },
            ],
            bannerHeight: "",
            bannerwidth: "",
            // 培训通知
            noticeData: [],

        }
    },
    mounted() {
        if (sessionStorage.getItem('currentSearchName')) {
            this.currentSearch = sessionStorage.getItem('currentSearchName')
        } else {
            this.currentSearch = '报名信息查询'
        }
        this.getNews()
        this.getCourseListFn()
        this.getMbaNews()
        // 获取领军人才课程信息
        // this.getlearInfo()
        // 走马灯高度
        this.imgLoad();
        // if (this.$refs.bannerHeight[0].height) {
        //     this.bannerHeight = this.$refs.bannerHeight[0].height;
        // }
        window.addEventListener('resize', this.yourFunctionReference)
        // this.getInforms()
    },

    methods: {
        yourFunctionReference() {
            if (this.$refs.bannerHeight && this.$refs.bannerHeight[0].height) {
                this.bannerHeight = this.$refs.bannerHeight[0].height;
            }
            this.imgLoad();
        },
        imgLoad() {
            this.$nextTick(() => {
                this.bannerHeight = this.$refs.bannerHeight[0].height;
                this.bannerwidth = document.body.clientWidth
            })
        },
        // 领军人才
        //  async getlearInfo() {
        //     httpService.getLeaderClass().then(res => {
        //         if (res.code == 200) {
        //             this.leartrainData = res.result
        //             this.status = res.result.status
        //         }else{
        //              this.$message.error(res.message);
        //         }
        //     })
        // },
        // leadsingupFn() {
        //     if (!this.islogin) {
        //         this.$message({
        //             message: '请先登录网站',
        //             type: 'warning'
        //         });
        //     } else {
        //         // 1提交 2审核通过 3审核失败
        //         // 現在判断是否能继续报名的状态还没有返回，auditResult是错误的
        //         if (!this.leartrainData.flag) {
        //             this.$message({
        //                 message: '您已报名成功，请等待审核，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
        //                 type: 'warning'
        //             });
        //         } else {
        //             this.leadsingupVisible = true
        //         }
        //         //  this.singupVisible = true
        //     }
        // },
        golearPageFn(item) {
            this.$router.push(item.url);
        },
        async getNews() {
            let params = {
                pageSize: 3,
                pageCurrent: 1,
                pressSuperClass: 8,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.DataList = data.result.list
            }
        },
        // async getInforms() {
        //     let params = {
        //         pageSize: 4,
        //         pageCurrent: 1,
        //         pressSuperClass: 8,
        //     };
        //     let data = await httpService.getNewsList(params);
        //     if (data.code == 200) {
        //         this.DataList = data.result.list
        //     }
        // },
        // 课程列表
        async getCourseListFn() {
            let params = {
                pageSize: 4,
                pageCurrent: 1,
                auditResult: 5,
            };
            let data = await httpService.getCourseList(params);
            if (data.code == 200) {
                this.CourseData = data.result.list
            }
        },
        async getMbaNews() {
            // let params = {
            //     pageSize: 8,
            //     pageCurrent: 1,
            // };
            // let data = await httpService.findThirdPartyCourse(params);
            // if (data.code == 200) {
            //     this.MbaData = data.result.list
            // }
            let params = {
                pageSize: 8,
                pageCurrent: 1,
                pressSuperClass: 112,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.MbaData = data.result.list
            }
        },
        // gotrainNotice() {
        //  },
        goNewsDetailFn(val) {
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        },
        changeSearchFn(item) {
            this.currentSearch = item.name
        },
        dialogSearchFn(item) {
            this.dialogcurrentSearch = item.name
            this.currentSearch = item.name
            let params = {
                pageCurrent: this.currentPage,
                pageSize: this.pageSize,
                ...this.ruleForm
            }
            if (this.dialogcurrentSearch == '报名信息') {
                httpService.findApply(params).then(res => {
                    if (res.code == 200) {
                        this.infoDataList = res.result.list
                        this.total = res.result.total
                    } else {
                        this.$message.error(res.message);
                    }
                })
            } else {
                httpService.findGrade(params).then(res => {
                    if (res.code == 200) {
                        this.certificateList = res.result.list
                        this.certificatetotal = res.result.total
                    } else {
                        this.$message.error(res.message);
                    }
                })
            }
        },
        // // 报名信息
        // searchApplyFn() {
        //     let params = {
        //         pageCurrent: this.pageCurrent,
        //         pageSize: this.pageSize,
        //         ...this.ruleForm
        //     }
        // },
        // 查询
        submitForm(formName) {
            // this.infoVisible = true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        pageCurrent: this.currentPage,
                        pageSize: this.pageSize,
                        ...this.ruleForm
                    }
                    if (this.currentSearch == '报名信息查询') {
                        httpService.findApply(params).then(res => {
                            if (res.code == 200) {
                                this.infoDataList = res.result.list
                                this.total = res.result.total
                                this.infoVisible = true
                                this.stopScroll()
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    } else {
                        this.dialogcurrentSearch = '成绩证书'
                        httpService.findGrade(params).then(res => {
                            if (res.code == 200) {
                                this.certificateList = res.result.list
                                this.certificatetotal = res.result.total
                                this.infoVisible = true
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    }
                } else {
                    return false;
                }
            });
        },
        // 关闭查询弹框
        // 关闭表单
        offmodalFn() {
            
            // this.currentSearch = '报名信息查询'
            // this.dialogcurrentSearch = '报名信息'
            if (this.dialogcurrentSearch == '报名信息') {
                this.currentSearch = '报名信息查询'
            } else {
                this.currentSearch = '成绩证书查询'
            }
            this.infoVisible = false
            this.canScroll()
        },
        leftFn() {
            let itemBox = this.$refs.itemBox;
            if (itemBox.style.transform) {
                let number = itemBox.style.transform.split("(")[1].split("p")[0] * 1;
                if (number < 0) {
                    itemBox.style.transform = `translateX(${308 + number}px)`;
                } else {
                    this.righticon = require("@/assets/imgs/branch/activaterighticon.png");
                    this.lefticon = require("@/assets/imgs/branch/lefticon.png")
                    return false;
                }
            } else {
                return false;
            }
        },
        rightFn() {
            let itemBox = this.$refs.itemBox;
            if (itemBox.style.transform) {
                let number = itemBox.style.transform.split("(")[1].split("p")[0] * 1;
                if (-((this.branchMenuList.length - 5.5) * 330) >= number) {
                    this.righticon = require("@/assets/imgs/branch/righticon.png");
                    this.lefticon = require("@/assets/imgs/branch/activatelefticon.png")
                    return false;
                } else {
                    itemBox.style.transform = `translateX(${-330 + number}px)`;
                }
            } else {
                itemBox.style.transform = `translateX(-330px)`;
            }
        },
        // 立即报名
        singUpFn(val) {
            if (this.token) {
                // 弹报名框
                this.singupVisible = true
                this.stopScroll()
                this.currentCourse = val
            }
            else {
                // 提示登录
                this.loginVisible = true
            }
        },
        // 报名成功
        successApplyFn() {
            this.singupVisible = false;
            this.canScroll()
            this.getCourseListFn()
        },
        // 课程详情
        gocourseDetailFn(val) {
            this.$router.push({
                path: "/course-detail",
                query: {
                    id: val.trainId,
                },
            });
        },
        showlogindialog() {
            this.loginVisible = true
        },
        offloginVisible() {
            this.loginVisible = false
        },
        gologin() {
            this.$router.push('/login');
        },
        gonewsecond() {
            this.$router.push('/tarin-secondpage/tripartite-train');
        },
        gonewsecond1() {

            this.$router.push('/tarin-secondpage/tarin-inform');
        },
        gonewsecond2() {
            this.$router.push('/tarin-secondpage/tarin-course');
        },
        jumpdetailFn() {
            this.$router.push('/course-detail');
        },
        goDetailMba(val) {
            if (val.status == 1) {
                this.$router.push({
                    path: "/course-detail",
                    query: {
                        id: val.trainId,
                    }
                });
            } else {
                this.$message.warning('当前课程暂未开班，敬请期待！')
            }
        },
        // 信息查询分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.dialogSearchFn(this.dialogcurrentSearch);
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.dialogSearchFn(this.dialogcurrentSearch);
        },
        // 下载
        downloadFn(item) {
            let Docurl = `${process.env.VUE_APP_GATEWAY}${'/upload/download?session='}${item}`
            window.open(Docurl)
        },
    },
    filters: {
        timer: (value) => {
            if (value) {
                return value.substring(0, 10);
            }
        },
    },
    beforeDestroy() {
        // window.removeEventListener('resize', () => {
        //     if (this.$refs.bannerHeight[0].height) {
        //         this.bannerHeight = this.$refs.bannerHeight[0].height;
        //     }
        //     this.imgLoad();
        // }, false);
        window.removeEventListener('resize', this.yourFunctionReference);
    }
}
</script>
<style lang="less" scoped>
.TrainingServicesWarp {
	width: 100%;
	margin: 0 auto;
	.topimgbox {
		width: 100%;
		// height: 405px;
		cursor: pointer;
	}
	.imgwarp {
		// width: 100%;
		// height: auto;
		// /deep/.el-carousel__container {
		// 	height: 100% !important;
		// }
		// // height: 230px;
		// img {
		// 	// width: 100%;
		// 	// height: 100%;
		// 	cursor: pointer;
		// }
		/deep/.el-carousel {
			width: 100%;
		}
	}
	.trainBox {
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		.commonTabTitleBox {
			border: none;
		}
		.rightsecondbox {
			margin: 16px 0;
		}
		.leftbox {
			width: 620px;
			margin-right: 36px;
			display: flex;
			flex-direction: column;
			.itemMbaBox {
				width: 620px;
				// height: 175px;
				border-radius: 6px;
				margin-bottom: 20px;
				position: relative;
				&:last-child {
					margin-bottom: 0px;
				}
				.mbaImg {
					width: 610px;
					// height: 175px;
					border-radius: 6px;
					z-index: -99;
					cursor: pointer;
				}
				.title {
					position: absolute;
					top: 0px;
					left: 0;
					text-align: center;
					line-height: 175px;
					font-size: 18px;
					color: #fff;
					font-weight: bold;
					width: 698px;
					height: 175px;
					background-color: rgba(0, 0, 0, 0.45);
				}
			}
			.mbaImg {
				width: 100%;
				height: 165px;
				border-radius: 6px;
				// z-index: -99;
				cursor: pointer;
			}
			.informBox {
				// width: 690px;
				.inforDataBox {
					// height: 500px;
					.inforItemBox {
						display: flex;
						flex-direction: row;
						margin-bottom: 34px;
						&:hover {
							.msgbox {
								.headlineBox {
									color: #0083ff;
								}
							}
						}
						&:first-child {
							padding-top: 15px;
						}
						&:last-child {
							margin-bottom: 0;
						}
						.imgbox {
							width: 140px;
							height: 80px;
						}
						.msgbox {
							width: 68%;
							padding: 0 0 0 18px;
							text-align: left;
							.headlineBox {
								width: 100%;
								cursor: pointer;
								line-height: 28px;
								color: #666666;
								font-size: 18px;
								text-overflow: -o-ellipsis-lastline;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								line-clamp: 1;
								-webkit-box-orient: vertical;
								font-weight: 550;
							}
							.time {
								line-height: 36px;
								color: #999999;
							}
						}
					}
				}
			}
		}
		.rightbox {
			width: 560px;
		}
		.informBox {
			width: 100%;
			.inforDataBox {
				// height: 500px;
				.inforItemBox {
					display: flex;
					flex-direction: row;
					margin-bottom: 20px;
					&:hover {
						.msgbox {
							.headlineBox {
								color: #0083ff;
							}
						}
					}
					&:first-child {
						padding-top: 15px;
					}
					&:last-child {
						margin-bottom: 0;
					}
					.imgbox {
						width: 140px;
						height: 80px;
					}
					.msgbox {
						width: 68%;
						padding: 0 0 0 18px;
						text-align: left;
						.headlineBox {
							width: 100%;
							cursor: pointer;
							line-height: 28px;
							color: #666666;
							font-size: 17px;
							text-overflow: -o-ellipsis-lastline;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 1;
							line-clamp: 1;
							-webkit-box-orient: vertical;
							font-weight: 550;
						}
						.time {
							line-height: 36px;
							color: #999999;
						}
					}
				}
			}
		}
	}
	.centerwarp {
		width: 1200px;
		margin: 40px auto 0 auto;
		.trainBox1 {
			display: flex;
			flex-direction: row;
			.informBox {
				width: 690px;
				.inforDataBox {
					// height: 500px;
					.inforItemBox {
						display: flex;
						flex-direction: row;
						margin-bottom: 15px;
						&:hover {
							.msgbox {
								.headlineBox {
									color: #0083ff;
								}
							}
						}
						&:first-child {
							padding-top: 15px;
						}
						&:last-child {
							margin-bottom: 0;
						}
						.imgbox {
							width: 149px;
							height: 93px;
						}
						.msgbox {
							width: 68%;
							padding: 0 0 0 18px;
							text-align: left;
							.headlineBox {
								width: 100%;
								cursor: pointer;
								line-height: 28px;
								color: #666666;
								font-size: 17px;
								text-overflow: -o-ellipsis-lastline;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								line-clamp: 2;
								-webkit-box-orient: vertical;
								font-weight: 550;
							}
							.time {
								line-height: 36px;
								color: #999999;
							}
						}
					}
				}
			}
			.infoSearchBox {
				width: 100%;
				// height: 440px;
				border: 1px solid #dfdfdf;
				padding: 6px 30px 16px 30px;
				box-sizing: border-box;
				margin-bottom: 18px;
				.searchTextBox {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					font-size: 20px;
					line-height: 28px;
					margin: 16px 0 24px 0;
					.searchItem {
						color: #333333;
						cursor: pointer;
					}
					.activesearchItem {
						cursor: pointer;
						color: #448df7;
					}
				}
				.formwarp {
					/deep/.el-form-item__label {
						min-width: 110px !important;
						text-align: left;
						font-size: 16px;
						font-weight: bold;
						line-height: 30px;
						color: #333333;
					}
					.submintBtn {
						width: 100%;
						font-size: 16px;
					}
				}
			}
		}
		.trainListBox {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.trainItem {
				margin: 0 16px 30px 0;
				width: 268px;
				min-height: 256px;
				// height: 280px;
				box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
				// background: url(../assets/imgs/tarin/bgimg1.png) no-repeat 100%;
				background: url(../assets/imgs/train/bgimg1.png) no-repeat 100% 100%;
				padding: 24px 26px 24px 20px;
				box-sizing: border-box;
				&:nth-child(2n) {
					margin-right: 0;
				}
				.name {
					font-size: 18px;
					font-weight: bold;
					line-height: 32px;
					color: #333333;
					position: relative;
					cursor: pointer;
					margin-bottom: 15px;
				}
				// .name::before {
				// 	content: '';
				// 	position: absolute;
				// 	width: 68px;
				// 	height: 0px;
				// 	border: 2px solid #448df7;
				// 	opacity: 1;
				// 	background: #448df7;
				// 	left: 0%;
				// 	// transform: translateX(-50%);
				// 	top: 32px;
				// }
				.courseinfobox {
					font-size: 16px;
					line-height: 30px;
					color: #666666;
					margin-bottom: 15px;
				}
				.deadlinebox {
					color: #c0c0c0;
				}
				.immediatelyBtn,
				.coursdeadline,
				.registeredbox {
					width: 118px;
					height: 32px;
					line-height: 32px;
					color: #fff;
					margin: 0 auto;
					text-align: center;
				}
				.immediatelyBtn {
					background: #448df7;
					cursor: pointer;
				}
				.coursdeadline {
					background: #c0c0c0;
					cursor: not-allowed;
				}
				.registeredbox {
					background: #4ab344;
				}
			}
		}
		.selectedCourseBox {
			display: flex;
			flex-direction: row;
			width: 1200px;
			margin: 10px auto 60px auto;
			align-items: center;
			justify-content: center;
			.leftarrowbox,
			.rightarrowbox {
				width: 34px;
				height: 34px;
			}
			.centerMenubox {
				width: 1200px;
				margin: 0 auto;
				box-sizing: border-box;
				display: flex;
				flex-direction: row;
				// .textbox {
				// 	width: 1200px;
				// 	margin: 0 auto;
				// 	overflow: hidden;
				// }
				// .itemBox {
				// width: 3500px;
				// height: 66px;
				// transition: all 0.8s;
				// display: flex;
				// flex-direction: row;
				// align-items: center;

				.Courseimg {
					width: 286px;
					height: 228px;
					// border: 1px solid red;
					margin-right: 20px;
					cursor: pointer;
					position: relative;
					img {
						width: 100%;
						height: 100%;
					}
					&:last-child {
						margin-right: 0px;
					}
					.textbox {
						width: 286px;
						height: 228px;
						position: absolute;
						top: 0;
						left: 0;
						// transform: translateX(-50%);
						background: rgba(0, 0, 0, 0.5);
						color: #fff;
						text-align: center;
						line-height: 228px;
						cursor: auto;
					}
				}
				// }
			}
		}
	}
	.dialogcenter {
		padding: 17px 60px 0px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		h3 {
			font-size: 22px;
			font-weight: bold;
			line-height: 32px;
			color: #333333;
			margin-bottom: 46px;
		}
		.text {
			height: 145px;
			font-size: 16px;
			line-height: 30px;
			color: #666666;
		}
	}
	.titleWarp {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-content: center;
		align-items: center;
		margin-bottom: 10px;
		.title {
			font-size: 22px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: 500;
			color: #333333;
			position: relative;
			padding-left: 16px;
			&::before {
				content: '';
				position: absolute;
				width: 2px;
				height: 20px;
				border: 1px solid #1875d9;
				opacity: 1;
				background: #1875d9;
				left: 0%;
				transform: translateX(-50%);
				top: 6px;
			}
		}
		.morebox {
			font-size: 16px;
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			color: #cacaca;
			margin: 0;
		}
	}
}
.dialogWarp {
	/deep/.singupdialogcenter {
		padding: 0px 40px 0px 40px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		align-items: center;
		.text {
			font-size: 22px;
			font-weight: bold;
			line-height: 32px;
			color: #333333;
			margin-bottom: 18px;
		}
		/deep/.el-form-item__label {
			font-size: 16px;
			// font-weight: bold;
			line-height: 30px;
			color: #333333;
		}
		.submintBtn {
			width: 152px;
			height: 40px;
			background: #448df7;
			color: #fff;
			margin: 0 20px;
			cursor: pointer;
			font-size: 16px;
			text-align: center;
			line-height: 40px;
		}
		.datawarp {
			width: 100%;
			border-top: 1px solid #e8e8e8;
			.searchbox {
				display: flex;
				flex-direction: row;
				justify-content: center;
				font-size: 20px;
				line-height: 28px;
				margin: 20px 0 48px 0;
				.searchItem {
					color: #333333;
					cursor: pointer;
					margin: 0 30px;
				}
				.activesearchItem {
					cursor: pointer;
					color: #448df7;
					margin: 0 30px;
				}
			}
			.datalistBox {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				padding: 0 90px;
				.trainItem {
					margin: 0 20px 30px 0;
					width: 286px;
					height: 240px;
					box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
					// background: url(../assets/imgs/tarin/bgimg1.png) no-repeat 100%;
					background: url(../assets/imgs/train/bgimg1.png) no-repeat 100% 100%;
					padding: 20px 30px 0 25px;
					box-sizing: border-box;
					&:nth-child(3n) {
						margin-right: 0;
					}
					.name {
						font-size: 16px;
						font-weight: bold;
						line-height: 24px;
						color: #448df7;
						position: relative;
						cursor: pointer;
						margin-bottom: 15px;
					}
					// .name::before {
					// 	content: '';
					// 	position: absolute;
					// 	width: 68px;
					// 	height: 0px;
					// 	border: 2px solid #448df7;
					// 	opacity: 1;
					// 	background: #448df7;
					// 	left: 0%;
					// 	// transform: translateX(-50%);
					// 	top: 32px;
					// }
					.courseinfobox {
						font-size: 14px;
						line-height: 30px;
						color: #666666;
						margin-bottom: 15px;
					}
					.deadlinebox {
						color: #c0c0c0;
					}
					// .immediatelyBtn,
					// .coursdeadline,
					// .registeredbox {
					// 	width: 118px;
					// 	height: 31px;
					// 	line-height: 31px;
					// 	color: #fff;
					// 	margin: 0 auto;
					// 	text-align: center;
					// }
					// .immediatelyBtn {
					// 	background: #448df7;
					// 	cursor: pointer;
					// }
					// .coursdeadline {
					// 	background: #c0c0c0;
					// }
					.registeredbox {
						width: 118px;
						height: 31px;
						line-height: 31px;
						color: #fff;
						margin: 0 auto;
						text-align: center;
						background: #f0cb15;
						// cursor: not-allowed;
					}
				}
			}
			.pdfdatabox {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				// justify-content: center;
				.pdfItem {
					width: 510px;
					height: 244px;
					background: #fff;
					box-shadow: 0px 3px 22px rgba(204, 213, 220, 0.76);
					border-radius: 12px;
					margin: 0 30px 30px 0px;
					padding: 16px;
					box-sizing: border-box;
					&:nth-child(2n) {
						margin-right: 0;
					}
					.pdftop {
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: center;
						font-size: 16px;
						line-height: 24px;
						color: #333333;
						margin-bottom: 20px;
						.certificateName {
							margin-right: 20px;
						}
					}
					.pdfbotbox {
						display: flex;
						flex-direction: row;
						.downbox {
							width: 106px;
							height: 141px;
							background: rgba(94, 206, 255, 0.39);
							position: relative;
							cursor: pointer;
							img {
								width: 64px;
								height: 80px;
								margin: 30px 20px 0 20px;
							}
							.downicon {
								position: absolute;
								bottom: 0px;
								left: 0px;
								font-size: 20px;
								color: #fff;
								width: 0;
								height: 0;
								border-bottom: 50px solid #8f8f8f;
								border-right: 50px solid transparent;
								cursor: pointer;
								.icon {
									margin: 27px 0px 0px 4px;
								}
							}
						}
						.courseinfobox {
							margin-left: 16px;
							width: 260px;
							.name {
								font-size: 16px;
								font-weight: bold;
								line-height: 24px;
								color: #333333;
							}
							.infotext {
								font-size: 14px;
								line-height: 30px;
								color: #8f8f8f;
							}
							.score {
								font-size: 18px;
								line-height: 24px;
								color: #0e83fc;
							}
						}
					}
				}
			}
			.searchempty {
				width: 100%;
				text-align: center;
				img {
					width: 193px;
					height: 155px;
				}
			}
		}
		// .formBtnBox {
		// 	display: flex;
		// 	fill-opacity: row;
		// 	justify-content: center;
		// 	cursor: pointer;
		// 	margin-top: 70px;
		// 	.submitBtn {
		// 		width: 152px;
		// 		height: 40px;
		// 		background: #349cff;
		// 		margin: 0 20px;
		// 		cursor: pointer;
		// 	}
		// }
	}
}
</style>


